// goes on Entretenimiento.js

import React from 'react'
import '../../Pages/Entretenimiento/entretenimiento.css';
import VerButton from '../VerButton';
import '../components-css/shop.css';

import {ReactComponent as PalokoIcon} from '../../assets/imgs/cards/entretenimiento/paloko.svg';
import {ReactComponent as MiniGolfIcon} from '../../assets/imgs/cards/entretenimiento/minigolf.svg';
import {ReactComponent as ObrasBrevesIcon} from '../../assets/imgs/cards/entretenimiento/obras-breves.svg';

import Paloko from '../../assets/imgs/cards/entretenimiento/bowling_.webp';
import MiniGolf from '../../assets/imgs/cards/entretenimiento/pelota-golf-new.webp';
import ObrasBreves from '../../assets/imgs/cards/entretenimiento/teatro.webp';

import IronDriverLogo from '../../assets/imgs/iron-driver/logo.png';
import CarIcon from './CarIcon';

export const PalokoCard = ({type, className}) => {
  return (
    <>
    <div className={`ent-card-wrapper ${className}`}>
        <div className='ent-card-container' style={
          type === "paloko" 
            ? {backgroundColor: '#E84E0F'} 
            : type === "minigolf" 
              ? {backgroundColor: '#20B2EB'} 
              : type === "iron-driver"
                ? {backgroundColor: '#000000'}
                : {backgroundColor: '#0A66B0'}
        }>
            <div className='ent-card-content-container' style={{overflow: 'hidden'}}>
                <div className='ent-card-header-wrapper'>
                    
                    <div className={`ent-svg-${type}`}>
                        {type === 'paloko' && <PalokoIcon/>}
                        {type === 'minigolf' && <MiniGolfIcon/>}
                        {type === 'obras-breves' && <ObrasBrevesIcon/>}
                        {type === 'iron-driver' && <img src={IronDriverLogo} style={{maxWidth: '90%', height: 'auto'}}/>}
                    </div>
                </div>
                <div className='ent-cover-wrapper'>
                    { type != 'iron-driver' ?
                    <img src={type === "paloko" ? Paloko : type === "minigolf" ? MiniGolf : ObrasBreves} className={`ent-cover`} alt='cover' />
                    :
                    <div style={{alignSelf: 'flex-end', maxWidth: '95%', height:'auto'}}>
                        <CarIcon/>
                    </div>
                    }
                </div>
            </div>
        </div>
        <div className='ent-card-description-wrapper'>
            <div className='ent-card-description'>
                {type === "paloko" && "¡Strikeee! Animate a disfrutar una partida de Bowling en Ronda"}
                {type === "minigolf" && "¡Hoyo en uno! Bienvenidos al MiniGolf"}
                {type === "obras-breves" && "Obras breves, un sin fin de emociones. ¡Que empiece el show!"}
                {type === "iron-driver" && "Los autos mas avanzados del mundo, la elite del automovilismo mundial."}
            </div>
            <VerButton link={`/entretenimiento/${type}#`}>Ver todo</VerButton>
        </div>
    </div>
    </>
  )
}
